module.exports = __webpack_public_path__ + "static/img/professional-services-card.339f3cf1.png";